import * as GQL from "src/types/graphql";
import { z } from "zod";

export const RuleType = GQL.form_engine_rule_type_enum;

export const FormEngineRuleFormSchema = z
  .object({
    configuration_type: z
      .enum(["DYNAMIC_SIBLING", "FORM_QUESTION", "AUTO_WAITLIST"])
      .optional(),
    id: z.string().uuid().optional(),
    rule_name: z
      .string({ required_error: "A rule name is required." })
      .trim()
      .min(1, "A rule name is required."),
    rule_key: z
      .string({ required_error: "A rule key is required." })
      .trim()
      .min(1, "A rule key is required."),
    userGeneratedKey: z.boolean().default(false),
    rule_description: z.string().default(""),
    rule_type: z.nativeEnum(RuleType).optional(),
    tag_ids: z.array(z.string().uuid()).default([]),
    enable_remove_tag: z.boolean().default(true),
    school_ids: z.array(z.string().uuid()).default([]),
    status: z.array(z.string()).default([]),
    question_id: z.string().uuid().nullable().default(null),
    answer_option_ids: z.array(z.string().uuid()).default([]),
    inside_outside: z.enum(["inside", "outside"]).nullable().default(null),
    boundary_type: z.enum(["all", "selected"]).nullable().default(null),
    boundary_ids: z.array(z.string().uuid()).default([]),
    source_statuses: z.array(z.string()).default([]),
    enable_automatic_offers: z.boolean().default(false),
  })
  .superRefine((data, ctx) => {
    if (!data.configuration_type) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Select when the tag should be applied.",
        path: ["configuration_type"],
      });
    }
  });

export type FormEngineRuleFormData = z.infer<typeof FormEngineRuleFormSchema>;

export type ConfigurationType = FormEngineRuleFormData["configuration_type"];
